"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLabel = exports.StyledLabelBox = exports.StyledWrapper = exports.StyledSliderBox = exports.StyledSliderMarkerCount = exports.StyledSliderMarker = exports.StyledRangeItem = exports.StyledRightCircle = exports.StyledLeftCircle = exports.StyledRangeItemBox = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const slider_1 = require("@reach/slider");
exports.StyledRangeItemBox = theme_1.styled.div `
  padding: 0 13px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: -6px;

  & [data-reach-slider][data-disabled] {
    opacity: 1 !important;
  }
`;
exports.StyledLeftCircle = theme_1.styled.span `
  position: absolute;
  background: ${({ theme }) => theme.colors.neutral[100]};
  border: 1px solid ${({ theme }) => theme.colors.neutral[0]};
  width: 6px;
  height: 6px;
  border-radius: 50%;
  left: 9px;
  bottom: 2px;
  z-index: 1;
  transition: all 0.3 ease;

  ${({ isFocused }) => isFocused &&
    (0, theme_1.css) `
      background: ${({ theme }) => theme.colors.neutral[30]};
    `}

  ${({ disabled }) => disabled &&
    (0, theme_1.css) `
      background: ${({ theme }) => theme.colors.neutral[30]};
    `}

  ${({ error }) => error &&
    (0, theme_1.css) `
      background: ${({ theme }) => theme.colors.accent.error.normal};
    `}
`;
exports.StyledRightCircle = theme_1.styled.span `
  position: absolute;
  background: ${({ theme }) => theme.colors.neutral[30]};
  border: 1px solid ${({ theme }) => theme.colors.neutral[0]};
  width: 6px;
  height: 6px;
  border-radius: 50%;
  right: 9px;
  bottom: 2px;
  z-index: 1;

  ${({ disabled }) => disabled &&
    (0, theme_1.css) `
      background: ${({ theme }) => theme.colors.neutral[30]};
    `}
`;
exports.StyledRangeItem = (0, theme_1.styled)(slider_1.Slider) `
  & [data-reach-slider-handle] {
    background: ${({ theme }) => theme.colors.neutral[0]};
    border: 2px solid ${({ theme }) => theme.colors.neutral[100]};
    width: 16px;
    height: 16px;
    border-radius: 50%;

    ${({ disabled }) => disabled &&
    (0, theme_1.css) `
        border-color: ${({ theme }) => theme.colors.neutral[30]};
      `}

    ${({ error }) => error &&
    (0, theme_1.css) `
        background: ${({ theme }) => theme.colors.neutral[0]};
        border-color: ${({ theme }) => theme.colors.accent.error.normal};
      `}
  }

  & [data-reach-slider-track][data-orientation='horizontal'] {
    height: 2px;
    background: ${({ theme }) => theme.colors.neutral[30]};
    left: 0.1%;

    ${({ disabled }) => disabled &&
    (0, theme_1.css) `
        background: ${({ theme }) => theme.colors.neutral[30]};
      `}

    ${({ error }) => error &&
    (0, theme_1.css) `
        background: ${({ theme }) => theme.colors.neutral[30]};
      `}
  }

  & [data-reach-slider-range] {
    background: ${({ theme }) => theme.colors.neutral[100]};
    width: 30px;
    transition: all 0.3 ease;

    ${({ isFocused }) => isFocused &&
    (0, theme_1.css) `
        background: ${({ theme }) => theme.colors.neutral[30]};
      `}

    ${({ disabled }) => disabled &&
    (0, theme_1.css) `
        background: ${({ theme }) => theme.colors.neutral[30]};
      `}

    ${({ error }) => error &&
    (0, theme_1.css) `
        background: ${({ theme }) => theme.colors.accent.error.normal};
      `}
  }
`;
const getStepFilledCircles = (val, step) => {
    const hasCircleFilled = val < step;
    if (hasCircleFilled) {
        return (0, theme_1.css) `
      background: ${({ theme }) => theme.colors.neutral[30]} !important;
    `;
    }
    else {
        return (0, theme_1.css) `
      background: ${({ theme }) => theme.colors.neutral[100]} !important;
    `;
    }
};
exports.StyledSliderMarker = (0, theme_1.styled)(slider_1.SliderMarker) `
  background: ${({ theme }) => theme.colors.neutral[30]};
  border: 2px solid ${({ theme }) => theme.colors.neutral[0]};
  width: 6px !important;
  height: 6px !important;
  border-radius: 50%;

  ${({ stepValue, filledStepsValue }) => stepValue && getStepFilledCircles(stepValue, filledStepsValue)}

  ${({ isFocused }) => isFocused &&
    (0, theme_1.css) `
      background: ${({ theme }) => theme.colors.neutral[30]} !important;
    `}

    ${({ disabled }) => disabled &&
    (0, theme_1.css) `
      background: ${({ theme }) => theme.colors.neutral[30]} !important;
    `}

    ${({ error }) => error &&
    (0, theme_1.css) `
      background: ${({ theme }) => theme.colors.accent.error.normal} !important;
    `}
`;
exports.StyledSliderMarkerCount = theme_1.styled.span `
  position: absolute;
  min-width: 80px;
  top: 13px;
  left: -22px;
  white-space: nowrap !important;

  ${theme_1.typography.regular14}
  line-height: 20px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;
exports.StyledSliderBox = theme_1.styled.div `
  position: relative;
`;
exports.StyledWrapper = theme_1.styled.div `
  position: relative;

  ${({ label }) => label &&
    (0, theme_1.css) `
      margin-top: 12px;
    `}
`;
exports.StyledLabelBox = theme_1.styled.div `
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-left: 8px;

  span {
    display: flex;
    margin-left: 6px;
  }
`;
exports.StyledLabel = theme_1.styled.label `
  ${theme_1.typography.regular18}
  color: ${({ theme }) => theme.colors.text.primary};
  letter-spacing: 0.01em;
`;
